import {Component, EventEmitter, Output, QueryList, ViewChildren} from '@angular/core';
import {ReportTableHeaderColumnComponent} from './report-table-header-column/report-table-header-column.component';

@Component({
  selector: 'app-report-table-header',
  templateUrl: './report-table-header.component.html',
  styleUrls: ['./report-table-header.component.scss']
})
export class ReportTableHeaderComponent {
  @ViewChildren(ReportTableHeaderColumnComponent) private reportCardHeaderColumnComponents: QueryList<ReportTableHeaderColumnComponent>;

  @Output() public onSort: EventEmitter<{ column: string, order: 'asc' | 'desc' | 'none'  }> = new EventEmitter<{ column: string, order: 'asc' | 'desc' | 'none'  }>();

  public sort: { column: string, order: 'asc' | 'desc' | 'none' };

  constructor() {}

  public onSortChange(value: { column: string, order: 'asc' | 'desc' | 'none'  }): void {
    for (const component of this.reportCardHeaderColumnComponents) {
      if (component.column !== value.column) {
        component.reset();
      }
    }

    this.onSort.emit(value);
    this.sort = value;
  }
}
